import React, { useEffect, useState } from 'react';

import { InputAdornment, MenuItem, Radio, TextField } from '@material-ui/core';

import { Autorenew as LoadingIcon } from '@material-ui/icons';

import { validateEmail } from '../../../utils';

import {
  createPaymentLink,
  fetchPaymentDetails,
  getSubscriptionPlans,
  getSubPlanTypes,
} from '../../../services/apiService';

import { toast } from 'react-toastify';

export default function CreateNewPaymentLink() {
  const [email, setEmail] = useState('');

  const [emailError, setEmailError] = useState(false);

  const courseList = ['data-science', 'web3', 'masters-ds', 'masters-cs'];

  const [hoursList, setHoursList] = useState([]);

  const [selectedCourse, setSelectedCourse] = useState('data-science');

  const [selectedHour, setSelectedHour] = useState(1);

  const [linkType, setLinkType] = useState('full_payment');
  const [downPayment, setDownPayment] = useState('ONE_FOURTH');

  const [couponCode, setCouponCode] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const [courseObj, setCourseObj] = useState({
    'data-science': {},
    web3: {},
    'masters-ds': {},
    'masters-cs': {},
  });

  const [amount, setAmount] = useState(null);

  const [loadingPaymentDetails, setLoadingPaymentDetails] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [paymentDetailErrorMsg, setpaymentDetailErrorMsg] = useState(null);

  const [loadingSendPaymentLink, setLoadingSendPaymentLink] = useState(false);
  const [sendPaymentLinkErrorMsg, setsendPaymentLinkErrorMsg] = useState(null);
  const [subPlanType, setSubPlanType] = useState(null);
  const [subPlanOptions, setSubPlanOptions] = useState([]);

  useEffect(async () => {
    if (['masters-ds', 'masters-cs'].includes(selectedCourse)) return;
    try {
      const apiData = {
        courseType: selectedCourse,
        planType: 'pro_live',
      };
      const response = await getSubPlanTypes(apiData);
      if (response.length) {
        const mappedArray = response.map((singleSubPlanType) => {
          return {
            name: singleSubPlanType?.subPlanName,
            value: singleSubPlanType?.subPlanType,
          };
        });
        setSubPlanType(mappedArray[0]?.value);
        setSubPlanOptions(mappedArray);
      }
    } catch (err) {
      console.error(err);
    }
  }, [selectedCourse]);

  const getAllCohortsAndMap = async () => {
    setIsLoading(true);
    const tempCrsObj = JSON.parse(JSON.stringify(courseObj));

    try {
      const response = await getSubscriptionPlans();
      for (let i = 0; i < response.length; i++) {
        const subscriptionItem = response[i];

        const goalType = subscriptionItem.goalType;

        if (goalType in tempCrsObj && subscriptionItem.paymentMode) {
          tempCrsObj[goalType][subscriptionItem.paymentMode] =
            subscriptionItem.cohortId
              ? [
                  {
                    cohortId: subscriptionItem.cohortId,
                    cohortName: subscriptionItem?.upcomingCohort?.name,
                  },
                ]
              : [];

          if (subscriptionItem.lastCohortId) {
            tempCrsObj[goalType][subscriptionItem.paymentMode].push({
              cohortId: subscriptionItem.lastCohortId,
              cohortName: subscriptionItem?.lastCohort?.name,
            });
          }
        }
      }

      setCourseObj(tempCrsObj);
    } catch (err) {
      console.error(err);
    }

    const tempHourList = [];
    for (let i = 1; i <= 24; i++) {
      tempHourList.push(i);
    }
    setHoursList(tempHourList);

    setIsLoading(false);
  };

  useEffect(() => {
    getAllCohortsAndMap();
  }, []);

  useEffect(() => {
    setAmount(null);
    setCouponCode(null);
  }, [linkType]);

  const handeleLinktypeClick = (event) => {
    setLinkType(event.target.value);
  };

  const getPaymentDetailsClickHandler = async () => {
    setEmailError(false);

    setpaymentDetailErrorMsg(null);

    if (!validateEmail(email)) {
      setEmailError(true);
      return;
    }

    setLoadingPaymentDetails(true);
    setPaymentDetails(null);

    try {
      const expiryInMs = Date.now() + selectedHour * 3600 * 1000;
      const isoHour = new Date(expiryInMs);
      const body = {
        email: email,
        goalType: selectedCourse,
        linkType: linkType,
        expiryDate: isoHour,
        paymentDetails: {
          couponCode: ['bajaj_payment', 'full_payment'].includes(linkType)
            ? couponCode
            : undefined,
          customAmount:
            amount * 100 > 0 &&
            ['partial_payment', 'masters_payment'].includes(linkType)
              ? amount * 100
              : undefined,
          downPaymentPercentage:
            linkType === 'bajaj_payment' ? downPayment : undefined,
        },
      };

      if (['data-science', 'web3'].includes(selectedCourse)) {
        body.subPlanType = subPlanType;
      }

      const response = await fetchPaymentDetails(body);
      setPaymentDetails(response);

      if (couponCode && couponCode.length > 0 && response.discountAmount <= 0) {
        toast.error('Invalid Coupon Code');
      }
    } catch (err) {
      console.error(err);
      setpaymentDetailErrorMsg(err.response.data.message);
    } finally {
      setLoadingPaymentDetails(false);
    }
  };

  const setPaymentLinkClickHandler = async () => {
    setEmailError(false);
    setsendPaymentLinkErrorMsg(null);

    if (!validateEmail(email)) {
      setEmailError(true);
      return;
    }

    setLoadingSendPaymentLink(true);

    try {
      const expiryInMs = Date.now() + selectedHour * 3600 * 1000;
      const isoHour = new Date(expiryInMs);

      const body = {
        email: email,
        goalType: selectedCourse,
        linkType: linkType,
        expiryDate: isoHour,
        paymentDetails: {
          couponCode: ['bajaj_payment', 'full_payment'].includes(linkType)
            ? couponCode
            : undefined,
          customAmount:
            amount * 100 > 0 &&
            ['partial_payment', 'masters_payment'].includes(linkType)
              ? amount * 100
              : undefined,
          downPaymentPercentage:
            linkType === 'bajaj_payment' ? downPayment : undefined,
        },
      };

      if (['data-science', 'web3'].includes(selectedCourse)) {
        body.subPlanType = subPlanType;
      }

      await createPaymentLink(body);
      toast.success('Payment link sent successfully.');
      setEmail('');
      setCouponCode('');
    } catch (err) {
      console.error(err);
      setsendPaymentLinkErrorMsg(err.response.data.message);
    } finally {
      setLoadingSendPaymentLink(false);
    }
  };

  return (
    <div>
      <div className='bg-gray-c2 p-8 font-medium'>
        <header className='flex'>
          <h1 className='text-3xl font-semibold ml-2'>
            Create New Payment Link
          </h1>
        </header>

        {isLoading ? (
          <div className='flex justify-center p-2'>Loading...</div>
        ) : (
          <div>
            <div className='flex gap-2 mt-8'>
              <div className='w-full'>
                <TextField
                  value={email}
                  variant='outlined'
                  label='Email'
                  fullWidth
                  onChange={(event) => {
                    setEmail(event.target.value);
                  }}
                />

                {emailError && (
                  <span className='text-red-700 text-sm'>
                    Please enter a valid email.
                  </span>
                )}
              </div>
            </div>

            <div className='flex gap-2 mt-8'>
              <TextField
                select
                value={selectedCourse}
                variant='outlined'
                label='Course'
                fullWidth
                onChange={(e) => {
                  const crs = e.target.value;
                  setSelectedCourse(crs);
                }}
              >
                {courseList.map((course) => (
                  <MenuItem value={course} key={course}>
                    {course}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            <div className='flex gap-2 mt-8'>
              <div className='flex gap-2  w-full'>
                {['data-science', 'web3'].includes(selectedCourse) &&
                  ['full_payment', 'bajaj_payment'].includes(linkType) && (
                    <TextField
                      value={couponCode}
                      variant='outlined'
                      label='Coupon Code'
                      fullWidth
                      onChange={(e) =>
                        setCouponCode(e.target.value.toUpperCase())
                      }
                    />
                  )}
                {['data-science', 'web3', 'masters-ds', 'masters-cs'].includes(
                  selectedCourse
                ) &&
                  ['partial_payment', 'masters_payment'].includes(linkType) && (
                    <TextField
                      variant='outlined'
                      label='Amount'
                      value={amount}
                      type='number'
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position='start'>₹</InputAdornment>
                        ),
                      }}
                      fullWidth
                      onChange={(e) => setAmount(e.target.value)}
                    />
                  )}

                <TextField
                  select
                  value={selectedHour}
                  variant='outlined'
                  label='Link Validity (hours)'
                  fullWidth
                  onChange={(e) => setSelectedHour(e.target.value)}
                >
                  {hoursList.map((course) => (
                    <MenuItem value={course} key={course}>
                      {course}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>

            {['data-science', 'web3'].includes(selectedCourse) &&
              ['full_payment', 'bajaj_payment'].includes(linkType) && (
                <div className='mt-8'>
                  <TextField
                    select
                    value={subPlanType}
                    variant='outlined'
                    label='Sub Plan Type'
                    fullWidth
                    onChange={(e) => {
                      setSubPlanType(e.target.value);
                    }}
                  >
                    {subPlanOptions.map((subPlanType, index) => (
                      <MenuItem value={subPlanType?.value} key={index}>
                        {subPlanType?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              )}

            <div className='flex mt-4'>
              <div className='w-full '>
                <div className='flex gap-4'>
                  <div>
                    <div className='text-gray-400 text-sm'>Type of Payment</div>

                    {!['masters-ds', 'masters-cs'].includes(selectedCourse) && (
                      <>
                        <div className='flex items-center -mb-2 -ml-2'>
                          <Radio
                            color='primary'
                            name='linkType'
                            value='full_payment'
                            checked={linkType === 'full_payment'}
                            onChange={handeleLinktypeClick}
                          />
                          <span className='text-sm font-normal opacity-60'>
                            Full Payment
                          </span>
                        </div>
                        <div className='flex items-center -mb-2 -ml-2'>
                          <Radio
                            color='primary'
                            name='linkType'
                            value='partial_payment'
                            checked={linkType === 'partial_payment'}
                            onChange={handeleLinktypeClick}
                          />
                          <span className='text-sm font-normal opacity-60'>
                            Partial Payment
                          </span>
                        </div>
                        <div className='flex items-center -mb-2 -ml-2'>
                          <Radio
                            color='primary'
                            name='linkType'
                            value='bajaj_payment'
                            checked={linkType === 'bajaj_payment'}
                            onChange={handeleLinktypeClick}
                          />
                          <span className='text-sm font-normal opacity-60'>
                            Bajaj Down Payment
                          </span>
                        </div>
                      </>
                    )}

                    {['masters-ds', 'masters-cs'].includes(selectedCourse) && (
                      <div className='flex items-center -mb-2 -ml-2'>
                        <Radio
                          color='primary'
                          name='linkType'
                          value='masters_payment'
                          checked={linkType === 'masters_payment'}
                          onChange={handeleLinktypeClick}
                        />
                        <span className='text-sm font-normal opacity-60'>
                          Masters Payment
                        </span>
                      </div>
                    )}
                  </div>
                  {!['masters-ds', 'masters-cs'].includes(selectedCourse) &&
                    linkType === 'bajaj_payment' && (
                      <div className='ml-8 '>
                        <div className='text-gray-400 text-sm'>
                          Down payment:
                        </div>

                        <div className='flex items-center '>
                          <Radio
                            color='primary'
                            name='downPayment'
                            value='ONE_FOURTH'
                            checked={downPayment === 'ONE_FOURTH'}
                            onChange={(event) => {
                              setDownPayment(event.target.value);
                            }}
                          />
                          <span className='text-sm font-normal opacity-60'>
                            ONE-FOURTH
                          </span>
                        </div>

                        <div className='flex items-center '>
                          <Radio
                            color='primary'
                            name='downPayment'
                            value='ONE_SEVENTH'
                            checked={downPayment === 'ONE_SEVENTH'}
                            onChange={(event) => {
                              setDownPayment(event.target.value);
                            }}
                          />
                          <span className='text-sm font-normal opacity-60'>
                            ONE-SEVENTH
                          </span>
                        </div>
                      </div>
                    )}
                </div>

                <div className='flex flex-col items-center'>
                  {paymentDetailErrorMsg && (
                    <span className='text-red-700 text-sm'>
                      Error: {paymentDetailErrorMsg}
                    </span>
                  )}

                  <div className='flex justify-center'>
                    <button
                      className='w-max bg-red-700 py-2 px-10 my-1 font-medium text-white text-sm rounded focus:outline-none'
                      disabled={loadingPaymentDetails}
                      onClick={getPaymentDetailsClickHandler}
                    >
                      {loadingPaymentDetails ? (
                        <LoadingIcon className='animate-spin' />
                      ) : (
                        'Get Payment Details'
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div className='w-full'>
                {paymentDetails && (
                  <div>
                    <div
                      className='p-4 font-semibold'
                      style={{ backgroundColor: '#EBF2FC' }}
                    >
                      Payment Details
                    </div>
                    <div className='p-4' style={{ backgroundColor: '#F5F9FF' }}>
                      {paymentDetails.courseEnrollmentAmount && (
                        <div className='flex py-1'>
                          <div className=' w-5/6 '>Course enrolment fee</div>
                          <div>{paymentDetails.courseEnrollmentAmount}</div>
                        </div>
                      )}
                      {paymentDetails.discountAmount && (
                        <div className='flex py-1'>
                          <div className=' w-5/6 '>Discount amount</div>
                          <div>{paymentDetails.discountAmount}</div>
                        </div>
                      )}

                      <div className='flex py-1'>
                        <div className=' w-5/6 '>Final amount</div>
                        <div>{paymentDetails.finalAmount}</div>
                      </div>

                      <div className='flex py-1'>
                        <div className=' w-5/6 '>Collectable amount</div>
                        <div>{paymentDetails.collectableAmount}</div>
                      </div>

                      <div className='flex flex-col items-center'>
                        {sendPaymentLinkErrorMsg && (
                          <span className='text-red-700 text-sm'>
                            Error: {sendPaymentLinkErrorMsg}
                          </span>
                        )}

                        <div className='flex justify-center'>
                          <button
                            className='w-max bg-blue-700 py-2 px-10 my-1 font-medium text-white text-sm rounded focus:outline-none'
                            disabled={loadingSendPaymentLink}
                            onClick={setPaymentLinkClickHandler}
                          >
                            {loadingSendPaymentLink ? (
                              <LoadingIcon className='animate-spin' />
                            ) : (
                              'Send Payment Link'
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
